module.exports = __webpack_public_path__ + "static/media/rajath.2c2d53e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rajath.jpg
// module id = 189
// module chunks = 0